import React, { forwardRef } from 'react';
import cn from 'classnames';
import BaseButton from './BaseButton';

const DownloadButton = forwardRef(({ title = 'Download', className, primary = true, ...props }, ref) => {
  const btnClassName = cn('save-button', { [className]: className });
  return (
    <BaseButton
      ref={ref}
      id='download-button'
      responsive
      
      type='submit'
      className={btnClassName}
      icon='download'
      title={title}
      primary={primary}
      {...props}

    />
  );
});

export default DownloadButton;
